<template>
  <div style="border-bottom: 3px solid rgb(237, 24, 72); position: relative;">
    <!-- div  :style="{'background-image': 'url(' + require('@/assets/mission.jpg') + ')'}" style="background-size: cover; background-position: center bottom;" -->
    <div  style="background-color: #424242; background-size: cover; background-position: center bottom;">

      <v-container flex grid-list-lg >

        <v-layout style="margin-top:0px;"
          wrap
        >

          <v-flex xs12 md5 xl4 offset-md1 offset-xl2 :style="{'background-image': 'url(' + require('@/assets/lisabackground.svg') + ')'}" style="background-size: 36%; background-position: left bottom; margin-bottom: -24px; padding-bottom:32px;">
            <v-card-text style="color: #eee !important;">
              <div class="display-2 font-weight-thin" >{{title}}</div>
              <v-card-text v-if="subtitle" class="subheading pb-0" style="color: #eee !important; white-space: pre;"><v-icon dark>{{icon1}}</v-icon> &nbsp; {{line1}}</v-card-text>
              <v-card-text v-if="subtitle" class="subheading pb-0" style="color: #eee !important; white-space: pre;"><v-icon dark>{{icon2}}</v-icon> &nbsp; {{line2}}</v-card-text>
              <v-card-text v-if="subtitle" class="subheading pb-0" style="color: #eee !important; white-space: pre;"><v-icon dark>{{icon3}}</v-icon> &nbsp; {{line3}}</v-card-text>
            </v-card-text>

          </v-flex>
          <v-flex v-if="subtitle" xs12 md5 xl4 style="margin-bottom: -24px; padding-bottom:32px;"  class="align-self-end">
            <v-card-text style="color: #eee !important;">
            <div class="body-2" >{{subtitle}}</div>
            </v-card-text>

        </v-flex>
        </v-layout>
      </v-container>

    </div>

  </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  components: {

  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'Title'
    },
    subtitle: {
      type: String,
      required: false,
      default: 'Subtitle'
    },
    line1: {
      type: String,
      required: false,
      default: ''
    },
    line2: {
      type: String,
      required: false,
      default: ''
    },
    line3: {
      type: String,
      required: false,
      default: ''
    },
    icon1: {
      type: String,
      required: false,
      default: ''
    },
    icon2: {
      type: String,
      required: false,
      default: ''
    },
    icon3: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      tabs: 0,
      tabs2: 0,
      panel: 0,
      expand: null,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    }
  },
  computed: {
    ...mapGetters({
      tabVersion: 'version/tabVersion'
    })
  },
  methods: {
    ...mapActions({
      updateTabVersion: 'version/updateTabVersion'
    })
  }
}
</script>

<style>

</style>
